/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

export const createRecoveryPasswordPageStyles = makeStyles(() => ({
  root: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
  },
  wrap: {
    width: '100%',
    maxWidth: '390px',
  },
  formTitle: {
    display: 'flex',
    fontSize: '24px',
    justifyContent: 'center',
  },
  subTitle: {
    marginBottom: '12px',
  },
  errorBlock: {
    marginTop: '10px',
    marginBottom: '5px',
    fontWeight: 500,
  },
  errorLine: {
    color: '#FA634E',
    margin: '2px 0px',
    marginLeft: '1.8rem',
  },
}));

export const createRecoveryPasswordFormStyles = makeStyles(() => ({
  root: {
    width: '100%',
    maxWidth: '390px',
  },
  formGroup: {
    minHeight: '66px',
    fontWeight: 500,
    marginBottom: '0.2rem',
    width: '100%',
  },
  formLine: {
    marginTop: '20px',
  },
  errorLine: {
    color: '#FA634E',
    margin: '2px 0px',
    marginLeft: '1.8rem',
  },
}));
